/* eslint-disable prettier/prettier */
<template>
  <div class="bootstrap-wrapper impressum">
    <div class="container">
      <div class="row">
        <div class="column col-12">
          <h3>Impressum</h3>
          <p>
            Dipl.-Psych. Katrin Lambrette<br />
            Buchenstraße 6<br />
            01097 Dresden<br />
            <a href="mailto:info@praxis-lambrette.de"
              >info@praxis-lambrette.de</a
            >
          </p>
          <ul class="info">
            <li>
              Bachelor of Science in Psychology verliehen von der
              <i>City University London</i>
            </li>
            <li>
              Diplom in Psychologie verliehen von der
              <i>Technischen Universität Dresden</i>
            </li>
            <li>
              Approbation als Psychologische Psychotherapeutin erteilt durch das
              <i>Regierungspräsidium Dresden</i>
            </li>
            <li>
              Akkreditierung als Supervisorin über das
              <i>Institut für Therapieforschung München</i> und die
              <i>Ostdeutsche Psychotherapeutenkammer</i>
            </li>
            <li>
              Zertifikat Fachpsychologin für Rechtspsychologie verliehen durch
              den
              <i>Berufsverband deutscher Psychologinnen und Psychologen</i> und
              die <i>Deutsche Gesellschaft für Psychologie</i>
            </li>
          </ul>
          <h4>Gesetzliche Aufsichtsbehörde:</h4>
          Ostdeutsche Psychotherapeutenkammer<br />
          Kickerlingsberg 14, 04105 Leipzig
          <h4>Maßgebliche berufsrechtliche Regelungen:</h4>
          Heilberufsgesetz, Psychotherapeutengesetz
          <p>
            Die Herausgeberin übernimmt keine Haftung für Inhalte außerhalb der
            Seiten von
            <a href="https://www.praxis-lambrette.de" target="_blank"
              >www.praxis-lambrette.de</a
            >, selbst wenn auf diese durch einen Link verwiesen wurde. Die
            Haftung trägt jeweils der dortige Betreiber. Alle Elemente dieser
            Seite sind urheberrechtlich geschützt. Eine Vervielfältigung
            einzelner oder mehrerer Elemente, Verwendung oder Abdruck von
            dargestellten Informationen – auch teilweise – ohne vorherige
            Genehmigung der Herausgeberin ist untersagt.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Impressum – Dipl.-Psych. Katrin Lambrette",
    meta: [
      {
        name: "description",
        content:
          "Fachpsychologin für Rechtspsychologie BDP/DGPs, Supervisorin IFT und Psychologische Psychotherapeutin"
      }
    ],
    htmlAttrs: {
      lang: "de",
      amp: true
    }
  }
};
</script>
